(function () {
    'use strict';

    angular
        .module('garanteasyApp')
        .controller('HomeController', HomeController);

    HomeController.$inject = ['$scope', 'Principal', 'LoginService', '$rootScope', '$state', '$timeout', 'Auth', 'Receipt'];

    function HomeController($scope, Principal, LoginService, $rootScope, $state, $timeout, Auth, Receipt) {
        var vm = this;

        vm.showMessageSaveMerchant = false;
        vm.showRegisterForm = true;
        if ($state.messageSave) {
            vm.showMessageSaveMerchant = true;
            vm.messageSave = $state.messageSave;
        }
        vm.account = null;
        vm.isAuthenticated = null;
        vm.login = LoginService.open;
        vm.register = register;
        vm.merchantRegister = merchantRegister;
        if (((Auth.getPreviousState() || {}).query || {}).username) {
            vm.username = Auth.getPreviousState().query.username;
            vm.showRegisterForm = false;
        }

        vm.closeAlert = function () {
            vm.show = false;
        }

        $scope.$on('authenticationSuccess', function () {
            getAccount();
        });

        getAccount();

        function getAccount() {
            Principal.identity().then(function (account) {
                vm.account = account;
                vm.isAuthenticated = Principal.isAuthenticated();
                if (vm.isAuthenticated) {
                    $state.go('dashboard');
                }
            });
        }
        function register() {
            $state.go('register');
        }
        function merchantRegister() {
            $state.go('register');
        }


        vm.login = function () {
            Auth.login({
                username: vm.username,
                password: vm.password,
                rememberMe: vm.rememberMe
            }).then(function () {
                vm.authenticationError = false;
                if ($state.current.name === 'register' || $state.current.name === 'activate' ||
                    $state.current.name === 'finishReset' || $state.current.name === 'requestReset' ||
                    $state.current.name === 'claimChiccoReceipt' || $state.current.name === 'home' ||
                    $state.current.name === 'social-auth' || $state.current.name === 'social-register') {
                    $state.go('receipt');
                }

                $rootScope.$broadcast('authenticationSuccess');

                // previousState was set in the authExpiredInterceptor before being redirected to login modal.
                // since login is succesful, go to stored previousState and clear previousState
                if (Auth.getPreviousState()) {
                    var previousState = Auth.getPreviousState();
                    Auth.resetPreviousState();
                    $state.go(previousState.name, previousState.params);
                }
            }).catch(function () {
                vm.authenticationError = true;
                vm.show = true;
            });
        }




        vm.requestResetPassword = function () {
            $state.go('requestReset');
        }
    }
})();
